import AlertDialog from "../components/AlertDialog";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useState, useEffect } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Typography, TextField, Button, Grid, Card, Alert } from "@mui/material";
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DescriptionIcon from '@mui/icons-material/Description';
import SecurityIcon from '@mui/icons-material/Security';
import ImageViewerModal from '../components/ImageViewerModal';
import { api } from "common";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CircularLoading from "components/CircularLoading";
import { colors } from "components/Theme/WebTheme";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  textField: {
    "& label.Mui-focused": {
      color: colors.MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: colors.MAIN_COLOR,
      },
    },
  },
  selectField: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.MAIN_COLOR,
    },
  },
  rootRtl: {
    "& label": {
      right: 0,
      left: "auto",
      paddingRight: 20,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 37,
    },
    "& label.Mui-focused": {
      color: colors.MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: colors.MAIN_COLOR,
      },
    },
  },
  rootRtl_2: {
    "& label": {
      right: 17,
      left: "auto",
      paddingRight: 12,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25,
    },
    "& label.Mui-focused": {
      color: colors.MAIN_COLOR,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiFilledInput-underline:after": {
      borderBottomColor: colors.MAIN_COLOR,
    },
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: colors.MAIN_COLOR,
      },
    },
  },
  selectField_rtl_2: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.MAIN_COLOR,
    },
    "& label": {
      right: 50,
      left: "auto",
      paddingRight: 12,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20,
    },
  },
  selectField_rtl_1: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.MAIN_COLOR,
    },
    "& label": {
      right: 50,
      left: "auto",
      paddingRight: 12,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25,
    },
  },

  selectField_rtl: {
    color: "black",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: colors.MAIN_COLOR,
    },
    "& label": {
      right: 50,
      left: "auto",
      paddingRight: 12,
    },
    "& legend": {
      textAlign: "right",
      marginRight: 15,
    },
  },

  right: {
    textAlign: "right",
    right: 0,
    left: "auto",
    paddingRight: 40,
  },
}));
const UpdateCar = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editCar, updateUserCar } = api;
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [driversObj, setDriversObj] = useState("");
  const [fleetMapObj, setFleetMapObj] = useState([]);
  const [role, setRole] = useState(null);
  const userdata = useSelector((state) => state.usersdata);
  const [drivers, setDrivers] = useState([]);
  const carlistdata = useSelector((state) => state.carlistdata);
  const [driverData, setDriverData] = useState(null);
  const [data, setData] = useState(null);
  const [oldData, setOldData] = useState(null);
  const [carData, setCardata] = useState();
  const [loading, setLoading] = useState(false);
  const [capacityValue,setCapacityValue]=useState("");
  const [carImageFile, setCarImageFile] = useState(null);
  const [regImageFile, setRegImageFile] = useState(null);
  const [insImageFile, setInsImageFile] = useState(null);
  const [viewerState, setViewerState] = useState({ open: false, src: '', title: '' });
  const classes = useStyles();
  const {state} = useLocation();

  // Drivers cannot edit fields when car is approved; admins always can
  const isReadOnly = role === 'driver' && data?.approved === true;

  useEffect(() => {
    if (carlistdata.cars) {
      const carData = carlistdata.cars.filter(
        (item) => item.id === id.toString()
      )[0];
      if (!carData) {
        navigate("/404");
      }
      const capacity_value = `${carData?.capacity || ''} ${carData?.unit_type || ''}`;
      setData(carData);
      setCapacityValue(capacity_value.trim()); 
      setOldData(carData);
    } else {
      setData([]);
    }
  }, [carlistdata.cars, id, navigate]);

  useEffect(() => {
    if (carlistdata.cars) {
      setCardata(carlistdata.cars);
    } else {
      setCardata([]);
    }
  }, [carlistdata.cars]);


  useEffect(() => {
    if (role !== "driver" && userdata.users) {
      let arr = userdata.users.filter(
        (user) =>
          user.usertype === "driver" &&
          ((role === "fleetadmin" &&
            user.fleetadmin &&
            user.fleetadmin === auth.profile.uid) ||
            role === "admin" || role === 'subadmin')
      );
      let obj = {};
      let obj2 = {};
      let arr2 = [];
      for (let i = 0; i < arr.length; i++) {
        let user = arr[i];
        arr2.push({
          id: user.id,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin
              ? user.mobile
              : t("hidden_demo")) +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo")),
        });
        obj[user.id] =
          user.firstName +
          " " +
          user.lastName +
          " (" +
          (settings.AllowCriticalEditsAdmin ? user.mobile : t("hidden_demo")) +
          ") " +
          (settings.AllowCriticalEditsAdmin ? user.email : t("hidden_demo"));
        obj2[user.id] = user.fleetadmin ? user.fleetadmin : null;
      }
      setDrivers(arr2);
      setDriversObj(obj);
      setFleetMapObj(obj2);
    }
  }, [
    userdata.users,
    settings.AllowCriticalEditsAdmin,
    role,
    auth.profile.uid,
    t,
  ]);

  useEffect(() => {
    setDriverData(
      auth.profile.firstName +
        " " +
        auth.profile.lastName +
        " (" +
        (settings.AllowCriticalEditsAdmin
          ? auth.profile.mobile
          : t("hidden_demo")) +
        ") " +
        (settings.AllowCriticalEditsAdmin
          ? auth.profile.email
          : t("hidden_demo"))
    );
  }, [
    auth.profile.lastName,
    auth.profile.mobile,
    auth.profile.email,
    settings.AllowCriticalEditsAdmin,
    auth.profile.firstName,
    t,
  ]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const getKeyByValue = (object, value) => {
    return Object.keys(object).find((key) => object[key] === value);
  };
  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handelChangeDriver = (event) => {
    const activeCarsWithSameDriver = carData?.filter(
        (car) => car.driver === oldData?.driver && car.active
    );
    if (activeCarsWithSameDriver?.length) {
        setCommonAlert({ open: true, msg: t('active_car_diver') });
        return;
    }
    setData({ ...data, driver: getKeyByValue(driversObj, event.target.value) });
  };
  const handleInputChange = (e) => {
    if (isReadOnly) return;
    setData({ ...data, [e.target.id]: e.target.value });
  };

  const handleBack = () => {
    if (state?.fromDriverCars && (state?.driverId || data?.driver || oldData?.driver)) {
      const driverId = state?.driverId || data?.driver || oldData?.driver;
      navigate(`/users/driverdetails/${driverId}`, { state: { tab: 2, pageNo: state?.pageNo } });
    } else {
      navigate('/cars', { state: { pageNo: state?.pageNo } });
    }
  };

  const handelSubmit = () => {
    settings.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
          setLoading(true);
          setTimeout(() => {
            resolve();
            if (data !== oldData) {
              let activeCar = null;
              let updateData = {
                carType: data.carType,
                vehicleNumber: data.vehicleNumber,
                vehicleMake: data.vehicleMake,
                vehicleModel: data.vehicleModel,
                car_color: data.car_color || data.vehicle_color || "",
                vehicle_color: data.car_color || data.vehicle_color || "",
                other_info: data.other_info,
                car_image: data.car_image,
                updateAt: new Date().getTime(),
              };
              for (let i = 0; i < carData.length; i++) {
                if (carData[i].driver === data.driver && carData[i].active) {
                  activeCar = carData[i];
                  break;
                }
              }
              if (activeCar && data.active) {
                activeCar.active = false;
                dispatch(editCar(activeCar, "Update"));
                dispatch(updateUserCar(data.driver, updateData));
              } else if (activeCar && !data.active) {
                data.active = false;
              } else {
                data.active = true;
                dispatch(updateUserCar(data.driver, updateData));
              }
              data["fleetadmin"] = data["fleetadmin"]
                ? fleetMapObj[data["driver"]]
                : null;
              delete data.tableData;
              const hasImageFiles = (data.car_image && typeof data.car_image !== 'string') ||
                (data.car_registration_image && typeof data.car_registration_image !== 'string') ||
                (data.car_insurance_image && typeof data.car_insurance_image !== 'string');
              dispatch(editCar({ ...data, hasNewCarUpload: true, carDocUpdated: true }, hasImageFiles ? "UpdateImage" : "Update"));
              if (data.driver !== oldData.driver && oldData.driver) {
                dispatch(
                  updateUserCar(oldData.driver, {
                    carType: null,
                    vehicleNumber: null,
                    vehicleMake: null,
                    vehicleModel: null,
                    other_info: null,
                    car_image: null,
                    updateAt: new Date().getTime(),
                  })
                );
              }
              handleBack();
            } else {
              setCommonAlert({ open: true, msg: t("make_changes_to_update") });
            }        
          }, 600);
          setLoading(false); 
        })
      : new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            setLoading(false);
            setCommonAlert({ open: true, msg: t('demo_mode') });
          }, 600);
        });
  };

  return loading ? (
    <CircularLoading />
  ) : (
    <>
      <div>
        <Card
          style={{
            borderRadius: "19px",
            backgroundColor: colors.WHITE,
            minHeight: 100,
            maxWidth: "75vw",
            marginTop: 20,
            marginBottom: 20,
            padding: 20,
            boxShadow: `0px 2px 5px ${colors.SECONDARY}`,
          }}
        >
          <Typography
            variant="h5"
            style={{
              margin: "10px 10px 0 5px",
              textAlign: isRTL === "rtl" ? "right" : "left",
            }}
          >
            {t("update_car_title")}
          </Typography>
          {isReadOnly && (
            <Alert severity="info" sx={{ mt: 2, mb: 1 }}>
              {t('car_approved_readonly')}
            </Alert>
          )}
          <div
           dir={isRTL === "rtl" ? "rtl" : "ltr"}
          >
            <Button
              variant="text"
              onClick={() => handleBack()}
            >
              <Typography
                style={{
                  margin: "10px 10px 0 5px",
                  textAlign: isRTL === "rtl" ? "right" : "left",
                  fontWeight: "bold",
                  color: colors.MAIN_COLOR,
                }}
              >
                {`<<- ${t("go_back")}`}
              </Typography>
            </Button>
          </div>
          <Grid
            container
            spacing={2}
            sx={{
              gridTemplateColumns: "50%",
              rowGap: "20px",
              marginY: 1,
              direction:isRTL === "rtl" ? "rtl" : "ltr",
            }}
          >
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                label={t("vehicle_reg_no")}
                id={"vehicleNumber"}
                value={data?.vehicleNumber || ""}
                fullWidth
                onChange={handleInputChange}
                disabled={isReadOnly}
                className={
                  isRTL === "rtl" ? classes.rootRtl_2 : classes.textField
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                label={t("vehicle_model_name")}
                id={"vehicleMake"}
                value={data?.vehicleMake || ""}
                fullWidth
                onChange={handleInputChange}
                disabled={isReadOnly}
                className={
                  isRTL === "rtl" ? classes.rootRtl : classes.textField
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                label={t("vehicle_model_no")}
                id={"vehicleModel"}
                value={data?.vehicleModel || ""}
                fullWidth
                onChange={handleInputChange}
                disabled={isReadOnly}
                className={
                  isRTL === "rtl" ? classes.rootRtl_2 : classes.textField
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                label={t("other_info")}
                id={"other_info"}
                value={data?.other_info || ""}
                fullWidth
                onChange={handleInputChange}
                disabled={isReadOnly}
                className={
                  isRTL === "rtl" ? classes.rootRtl : classes.textField
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                label={t("car_color", "Color")}
                id={"car_color"}
                value={data?.car_color || ""}
                fullWidth
                onChange={handleInputChange}
                disabled={isReadOnly}
                className={
                  isRTL === "rtl" ? classes.rootRtl_2 : classes.textField
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                label={t("production_year", "Production Year")}
                id={"car_production_year"}
                value={data?.car_production_year || ""}
                fullWidth
                onChange={handleInputChange}
                disabled={isReadOnly}
                className={
                  isRTL === "rtl" ? classes.rootRtl : classes.textField
                }
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
              <TextField
                label={t("carcapacity")}
                id={"carcapacity"}
                value={capacityValue}
                fullWidth
                disabled
                className={
                  isRTL === "rtl" ? classes.rootRtl : classes.textField
                }
              />
            </Grid>

         {role ==='driver'?null:   <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              xl={6}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <FormControl
                fullWidth
                style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
              >
                <InputLabel
                  id="demo-simple-select-label"
                  className={isRTL === "rtl" ? classes.right : ""}
                  sx={{ "&.Mui-focused": { color: colors.MAIN_COLOR } }}
                >
                  {t("driver")}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={
                    role === "fleetadmin"
                      ? driversObj[data?.driver] || ""
                      : role === "driver"
                      ? auth.profile.id
                      : (role === "admin" || role === 'subadmin')
                      ? driversObj[data?.driver] || ""
                      : ""
                  }
                  disabled={role === "driver" ? true : false}
                  label={t("driver")}
                  onChange={handelChangeDriver}
                  className={
                    isRTL === "rtl"
                      ? classes.selectField_rtl
                      : classes.selectField
                  }
                >
                  {(role === "admin" || role === 'subadmin')? (
                    drivers ? (
                      drivers.map((e) => (
                        <MenuItem
                          key={e.id}
                          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                          value={driversObj[e.id]}
                        >
                          {e.desc}
                        </MenuItem>
                      ))
                    ) : null
                  ) : role === "driver" ? (
                    <MenuItem
                      style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                      value={auth.profile.id}
                    >
                      {driverData}
                    </MenuItem>
                  ) : role === "fleetadmin" ? (
                    drivers ? (
                      drivers.map((e) => (
                        <MenuItem
                          key={e.id}
                          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
                          value={driversObj[e.id]}
                        >
                          {e.desc}
                        </MenuItem>
                      ))
                    ) : null
                  ) : null}
                </Select>
              </FormControl>
            </Grid>}
            
            {/* Document Images Section */}
            <Grid item xs={12}>
              <Typography variant="h6" style={{ marginTop: 10, marginBottom: 5, fontWeight: 'bold' }}>
                {t('car_documents', 'Car Documents')}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              {renderImageSlot(
                t('car_image', 'Car Image'),
                data?.car_image,
                carImageFile,
                'update-car-image-file',
                <DirectionsCarIcon sx={{ fontSize: 44, color: '#94a3b8' }} />,
                isReadOnly,
                (file) => {
                  setCarImageFile(file);
                  setData({ ...data, car_image: file });
                }
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              {renderImageSlot(
                t('car_registration', 'Car Registration'),
                data?.car_registration_image,
                regImageFile,
                'update-car-reg-file',
                <DescriptionIcon sx={{ fontSize: 44, color: '#94a3b8' }} />,
                isReadOnly,
                (file) => {
                  setRegImageFile(file);
                  setData({ ...data, car_registration_image: file });
                }
              )}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
              {renderImageSlot(
                `${t('car_insurance', 'Car Insurance')} (${t('optional', 'Optional')})`,
                data?.car_insurance_image,
                insImageFile,
                'update-car-ins-file',
                <SecurityIcon sx={{ fontSize: 44, color: '#94a3b8' }} />,
                false, // Car Insurance is ALWAYS editable
                (file) => {
                  setInsImageFile(file);
                  setData({ ...data, car_insurance_image: file });
                }
              )}
            </Grid>

            {!isReadOnly && (
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Button
                  style={{
                    borderRadius: "19px",
                    backgroundColor: colors.MAIN_COLOR,
                    minHeight: 50,
                    minWidth: "100%",
                    textAlign: "center",
                  }}
                  onClick={handelSubmit}
                  variant="contained"
                >
                  <Typography
                    style={{
                      color: colors.WHITE,
                      textAlign: "center",
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    {t("update")}
                  </Typography>
                </Button>
              </Grid>
            )}
            {isReadOnly && (insImageFile || (data?.car_insurance_image && typeof data?.car_insurance_image !== 'string')) && (
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Button
                  style={{
                    borderRadius: "19px",
                    backgroundColor: colors.MAIN_COLOR,
                    minHeight: 50,
                    minWidth: "100%",
                    textAlign: "center",
                  }}
                  onClick={handelSubmit}
                  variant="contained"
                >
                  <Typography
                    style={{
                      color: colors.WHITE,
                      textAlign: "center",
                      fontSize: 16,
                      fontWeight: "bold",
                    }}
                  >
                    {t('save_insurance', 'Save Insurance')}
                  </Typography>
                </Button>
              </Grid>
            )}
          </Grid>
        </Card>
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
          {commonAlert.msg}
        </AlertDialog>
      </div>
      <ImageViewerModal
        open={viewerState.open}
        src={viewerState.src}
        title={viewerState.title}
        onClose={() => setViewerState({ open: false, src: '', title: '' })}
      />
    </>
  );
};

// Reusable image slot renderer for document uploads
const renderImageSlot = (title, existingUrl, localFile, fileInputId, defaultIcon, disabled, onFileChange) => {
  const imageSrc = localFile
    ? URL.createObjectURL(localFile)
    : (typeof existingUrl === 'string' && existingUrl.trim() !== '' ? existingUrl : null);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 8, textAlign: 'center' }}>
        {title}
      </Typography>
      {imageSrc ? (
        <div
          style={{
            width: '100%',
            height: 160,
            borderRadius: 10,
            border: '1px solid #e2e8f0',
            backgroundColor: '#f1f5f9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            position: 'relative',
            opacity: disabled ? 0.5 : 1,
            filter: disabled ? 'grayscale(60%)' : 'none',
          }}
        >
          <img
            src={imageSrc}
            alt={title}
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            onError={(e) => {
              e.target.style.display = 'none';
              if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
            }}
          />
          <div style={{ display: 'none', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
            {defaultIcon}
          </div>
        </div>
      ) : (
        <div
          style={{
            width: '100%',
            height: 160,
            borderRadius: 10,
            border: '2px dashed #cbd5e1',
            backgroundColor: '#f8fafc',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 10,
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? 'default' : 'pointer',
          }}
          onClick={() => {
            if (!disabled) {
              const fi = document.getElementById(fileInputId);
              if (fi) fi.click();
            }
          }}
        >
          {defaultIcon}
          <Typography variant="caption" style={{ color: '#64748b', marginTop: 6, fontWeight: 500, textAlign: 'center' }}>
            No Document Uploaded
          </Typography>
        </div>
      )}
      {!disabled && (
        <div style={{ marginTop: 8, textAlign: 'center' }}>
          <input
            accept="image/*"
            style={{ display: 'none' }}
            id={fileInputId}
            type="file"
            onChange={(e) => {
              const f = e.target.files[0];
              if (f && onFileChange) onFileChange(f);
            }}
          />
          <label htmlFor={fileInputId}>
            <Button variant="outlined" component="span" style={{ fontSize: 11, padding: '4px 12px' }}>
              {localFile ? localFile.name : (imageSrc ? 'Change' : 'Upload')}
            </Button>
          </label>
        </div>
      )}
    </div>
  );
};

export default UpdateCar;
